import { ReplyOrder } from '@diritto/common/reply/constants';
import { QueryKey } from 'constants/reactQuery';

export const repliesQueryKey = {
  reply: (id: number) => [QueryKey.Reply, id] as const,
  replies: (categoryIds?: number[]) => [QueryKey.Reply, 'replies', categoryIds?.slice().sort()] as const,

  reReply: (id: number, orderBy: ReplyOrder) => [...repliesQueryKey.reply(id), QueryKey.ReReply, orderBy] as const,

  replyLikes: [QueryKey.Reply, QueryKey.ReplyLike] as const,
  replyLikeList: (replyIds: number[]) => [...repliesQueryKey.replyLikes, replyIds.join('|')] as const,

  profileReplies: [QueryKey.Reply, QueryKey.Profile] as const,
  profileReplyRoot: (profileId: number) => [...repliesQueryKey.profileReplies, profileId] as const,
  profileReplyList: (profileId: number, orderBy: ReplyOrder) =>
    [...repliesQueryKey.profileReplyRoot(profileId), { orderBy }] as const,
  profileReplyCount: (profileId: number) => [...repliesQueryKey.profileReplyRoot(profileId), 'count'] as const,

  contentReplies: [QueryKey.Reply, QueryKey.Content] as const,
  contentReplyRoot: (contentId: number) => [...repliesQueryKey.contentReplies, contentId] as const,
  contentReplyList: (contentId: number, orderBy: ReplyOrder) =>
    [...repliesQueryKey.contentReplyRoot(contentId), { orderBy }] as const,

  episodeReplies: [QueryKey.Reply, QueryKey.Episode] as const,
  episodeReplyRoot: (episodeId: number) => [...repliesQueryKey.episodeReplies, episodeId] as const,
  episodeReplyList: (episodeId: number, orderBy: ReplyOrder) =>
    [...repliesQueryKey.episodeReplyRoot(episodeId), { orderBy }] as const,
};
